import type { IOffer } from 'shared/offer';
import { getIsCpcAuction } from 'shared/utils/auction';

export type TPromotionType = 'cpc' | 'cpt';

/**
 * Определяет тип продвижения объявления для телеметрии показов, либо null — если объявление не продвигается.
 *
 * - `cpc` — объявление в пилоте CPC-аукциона (offer.auction.isCpcAuction + фича-флаг auction.cpcEnabled).
 * - `cpt` — платное размещение услугами (оплата за время): куплен любой VAS-тир Top3 / Premium / Standard.
 *   Именно эти флаги приходят сырыми с бэкенда и видны обычному искателю (в отличие от
 *   promotion.promotionDescription, который рендерится только не-искателям и для поиска всегда пуст).
 *
 * CPC имеет приоритет над CPT: объявление в пилоте аукциона считаем cpc, даже если у него есть VAS-тир.
 *
 * @param offer — объявление
 * @param isCpcAuctionEnabled — значение фича-флага `auction.cpcEnabled`
 */
export function getPromotionType(offer: IOffer, isCpcAuctionEnabled: boolean): TPromotionType | null {
  if (isCpcAuctionEnabled && getIsCpcAuction(offer)) {
    return 'cpc';
  }

  if (offer?.isTop3 || offer?.isPremium || offer?.isStandard) {
    return 'cpt';
  }

  return null;
}
